import { z } from 'zod';

export const registrationStepFiveSchema = z.object({
    purpose: z.enum(['love', 'fun', 'not_specified']).nullable(),
});

export type RegistrationStepFiveType = z.infer<typeof registrationStepFiveSchema>;
